import { createContext, useContext } from 'react';

export const CreatePetitionUpdateContext = createContext<boolean>(false);
export const useCreatePetitionUpdateContext = () => useContext(CreatePetitionUpdateContext);
